/*
 * @Author: suliyu
 * @Date: 2017年10月23日10:49:27
 * @Description: axios拦截器
 * @Last Modified by: wanghf
 * @Last Modified time: 2026-03-25 15:18:54
 */

import { configUrl } from '@/lib/configUrl'
import { Message } from 'element-ui'
import router from '../router'

const interceptors = {
  /**
   * request拦截
   * 在发送请求之前做某件事
   */
  request: {
    error: err => {
      return Promise.reject(err)
    },
    success: request => {
      return request
    }
  },

  /**
   * response拦截
   * 返回状态判断
   */
  response: {
    error: err => {
      // 下面是接口回调的satus ,会指向对应的报错页面
      if (err.response && err.response.status) {
        if (err.response.status === 401) {
          localStorage.removeItem('isAlert')
          sessionStorage.removeItem('accessToken')
          const href = window.location.href
          if (href.indexOf('/aq/login') === -1 && href.indexOf('/aq/authLogin') === -1) {
            if (href.indexOf('/aq/pp-auth') !== -1) {
              location.href = `/aq/authLogin${location.search}`
            } else {
              router.push({
                path: '/aq/login'
              })
            }
          }
        }

        if (err.response.status === 404) {
          router.push({
            path: '/error404'
          })
        }
      } else {
        Message({
          duration: 5000,
          type: 'error',
          message: window.vm.$i18n.t('components.global.netError') // "网络请求超时，请稍后再试");
        })
      }
    },
    success: res => {
      const code = res.data && res.data.code ? res.data.code : 999
      if (res.status === 200) {
        if (res.data && code === 200) {
          const resData = res.data.data
          //   console.error('====', res)
          const currentUrl = res.request._url?.split('?')[0]
          //   console.log('====url', configUrl, currentUrl)
          /**
		   * 历史原因，需要兼容返回格式
		   * 1.一些接口需要返回msg作为弹窗提示内容，
		   * 2.一些接口返回{}不需要额外处理，目前把这些接口放在uslList里面单独过滤 直接返回data
		   */
          const urlList = [
            configUrl + '/group/list',
		  	configUrl + '/merchant/acquirer/store/list',
            configUrl + '/merchant/acquirer/announcement/getEffectiveList'
		  ]
          //   console.log('====urlList', urlList)
          if (res.data.data || typeof res.data.data === 'boolean') {
            if (res.data.total) {
              return res.data
            } else if (typeof resData === 'object' && !Array.isArray(resData) && Object.keys(resData).length === 0) {
              if (urlList.includes(currentUrl)) {
                return res.data.data
			  } else {
                return res.data.msg
			  }
            } else {
              return res.data.data
            }
          } else {
            return res.data.msg
          }
        } if (res.data && code === 500) {
          if (res.data.msg === 'Transaction failed (duplicated Transaction)') {
            Message({
              type: 'error',
              message: 'Payment request has been initiated, please continue to pay on the original page or try it again after 15 minutes.'
            })
          } else {
            Message({
              duration: 5000,
              type: 'error',
              message: res.data.msg || res.data.message || res.data.statusText || window.vm.$i18n.t('components.global.netBusy')
            })

            return false
          }
        } else if (code === 401) {
          // 用户未登录或登录超时 跳转至登录页面

          window.location.href = `${configUrl}/aq/login.htm`
        } else {
          if (res.data.msg) {
            Message({
              duration: 5000,
              type: 'error',
              message: res.data.msg
            })
          } else {
            Message({
              duration: 5000,
              type: 'error',
              message: res.data.message
            })
          }
        }
      } else {
        // Message({
        //   duration: 5000,
        //   type: "error",
        //   message: `${window.vm.$i18n.t('components.global.netBusy')}${res.status}：${res.statusText}）`
        // })

        Message({
          duration: 5000,
          type: 'error',
          message: res.data.msg || res.data.message || res.data.statusText || window.vm.$i18n.t('components.global.netBusy')
        })
      }
    }
  }
}

export default interceptors
